import ng from 'angular';
import {
    AuthContextService,
    NavigationService
} from '@/services';
import { UiRights } from '@/configuration';

import './panel-incomplete-user-profile.scss';

export class MoleculePanelIncompleteUserProfileController implements ng.IController {
    public static $inject: string[] = ['navigation'];

    constructor(
        private navigation: NavigationService
    ) {}

    public goToContactDetailsPage = (): void => {
        void this.navigation.go('account.contactdetails');
    };

    public get hasAccountEditRights(): boolean {
        return AuthContextService.isGranted(UiRights.ACC_ACCOUNT_BASICDATA_EDIT);
    }
}

export class MoleculePanelIncompleteUserProfileComponent implements ng.IComponentOptions {
    public controller =  MoleculePanelIncompleteUserProfileController;
    public template = require('./panel-incomplete-user-profile.html');
}
